// MUI components
import { useContext } from 'react'
import { IntakeContext } from '../context/IntakeContext'

import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import HelpIcon from '@mui/icons-material/Help'
import { IconButton, Tooltip, Fade } from '@mui/material'

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'

const dollarFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

const OnboardingPaystub = () => {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)
  const isGovernmentEmployee = intakeState.governmentEmployee

  if (!isGovernmentEmployee) {
    return (
      <Box sx={{ textAlign: 'left' }}>
        <Box>
          <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
            Let’s go over your key pay details!
          </Typography>
        </Box>
        <SoftBox component="form" py={3}>
          <Grid container>
            <Grid item xs={12}>
              <Box mb={2}>
                <Typography variant="body1Medium">Key Pay Details</Typography>
              </Box>
              {renderMuiFormField({
                id: 'netTakeHome',
                enableHelpText: true,
                helpText:
                  'How much you take home in a normal pay period net of all deductions',
                label: (
                  <>
                    <span>
                      Net Take Home per Pay Period
                      <span style={{ color: 'red' }}> *</span>
                    </span>
                  </>
                ),
                placeholder: intakeState.baseSalary
                  ? dollarFormat.format((intakeState.baseSalary / 26) * 0.5)
                  : '$1,600.00',
                inputType: 'currencyFloat',
                value: intakeState.netTakeHome,
                onChange: (netTakeHome) =>
                  updateIntakeStateAtKey({ netTakeHome }),
              })}
            </Grid>
          </Grid>
        </SoftBox>
      </Box>
    )
  } else {
    return (
      <Box sx={{ textAlign: 'left' }}>
        <Box>
          <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
            Let's get started!
          </Typography>
        </Box>
        {/* <Typography variant="body2" fontSize={{ xs: '16px', sm: '20px' }}>
          First we need to know your name, phone number, and birthday
        </Typography> */}
        <SoftBox component="form" py={3}>
          <Grid container>
            <Grid item xs={12} mb={2}>
              <Box mb={2}>
                <Typography variant="body1Medium">
                  Key Pay & Pension Details
                </Typography>
              </Box>
              {renderMuiFormField({
                autoFocus: false,
                id: 'baseSalary',
                enableHelpText: true,
                helpText:
                  'Your Adjusted base salary is your base salary including any locality pay you receive.',
                label: (
                  <>
                    <span>
                      Adjusted Base Annual Salary
                      <span style={{ color: 'red' }}> *</span>
                    </span>
                  </>
                ),
                placeholder: '$62,000.00',
                inputType: 'currencyFloat',
                value: intakeState.baseSalary || 0,
                onChange: (baseSalary) => {
                  updateIntakeStateAtKey({ baseSalary: baseSalary })
                  // updateIntakeStateAtKey({
                  //   highThree: baseSalary * 0.96,
                  // })
                },
              })}
            </Grid>
            <Grid item xs={12} mb={2}>
              {renderMuiFormField({
                autoFocus: false,
                id: 'highThree',
                enableHelpText: true,
                helpText:
                  'Highest three consecutive years of service. Used to calculate your pension',
                label: (
                  <>
                    <span>
                      High Three
                      <span style={{ color: 'red' }}> *</span>
                    </span>
                  </>
                ),
                placeholder: intakeState.baseSalary
                  ? dollarFormat.format(intakeState.baseSalary * 0.96)
                  : '$62,000.00',
                inputType: 'currencyFloat',
                value: intakeState.highThree,
                onChange: (highThree) =>
                  updateIntakeStateAtKey({ highThree: highThree }),
              })}
            </Grid>
            <Grid item xs={12}>
              {renderMuiFormField({
                id: 'netTakeHome',
                enableHelpText: true,
                helpText:
                  'How much you take home in a normal pay period net of all deductions',
                label: (
                  <>
                    <span>
                      Net Take Home per Pay Period
                      <span style={{ color: 'red' }}> *</span>
                    </span>
                  </>
                ),
                placeholder: intakeState.baseSalary
                  ? dollarFormat.format((intakeState.baseSalary / 26) * 0.5)
                  : '$1,600.00',
                inputType: 'currencyFloat',
                value: intakeState.netTakeHome,
                onChange: (netTakeHome) =>
                  updateIntakeStateAtKey({ netTakeHome }),
              })}
            </Grid>
          </Grid>
        </SoftBox>
      </Box>
    )
  }
}

export default OnboardingPaystub
